import React, { useState } from "react";
import { aColor } from "./utils";

const Av = ({ user, size = 26 }) => {
  const [tip, setTip] = useState(false);
  if (!user) return null;

  const ini =
    [user.first_name?.[0], user.last_name?.[0]]
      .filter(Boolean)
      .join("")
      .toUpperCase() ||
    (user.name?.[0] || "?").toUpperCase();

  const name =
    user.name ||
    `${user.first_name || ""} ${user.last_name || ""}`.trim() ||
    "?";

  return (
    <div
      style={{ position: "relative", display: "inline-block" }}
      onMouseEnter={() => setTip(true)}
      onMouseLeave={() => setTip(false)}
    >
      <div
        style={{
          width: size,
          height: size,
          borderRadius: "50%",
          background: aColor(user.id),
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: size * 0.36,
          fontWeight: 700,
          border: "2px solid #fff",
          flexShrink: 0,
          userSelect: "none",
        }}
      >
        {ini}
      </div>

      {tip && (
        <div
          style={{
            position: "absolute",
            bottom: "calc(100% + 6px)",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#1e293b",
            color: "#fff",
            borderRadius: 7,
            padding: "5px 10px",
            fontSize: 10.5,
            fontWeight: 600,
            whiteSpace: "nowrap",
            zIndex: 9999,
            pointerEvents: "none",
            boxShadow: "0 4px 12px rgba(0,0,0,.25)",
          }}
        >
          {name}
          {user.email && (
            <div style={{ fontSize: 9.5, color: "#94a3b8", marginTop: 1 }}>
              {user.email}
            </div>
          )}
          <div
            style={{
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              border: "4px solid transparent",
              borderTopColor: "#1e293b",
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Av;
